import React from 'react';
import Layout from '../layouts/base.dark';
import ReactDOM from 'react-dom';
import { humanize_user } from '../../helpers';
import BlackOverlay from '../partials/black_overlay';
import { Animated } from 'react-animated-css';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import request from 'superagent';
import config from '../../config';
import fakeAuth from '../../fakeAuth';
import MaskedInput from 'react-text-mask';
import moment from 'moment';
import _ from 'lodash';

class Invitation extends React.Component {
    state = {
        redirectToReferrer: false,
        mode: 1,
        invalid: false,
        invalidFields: {},
        selectedBg: null,
        message: null,
        email: null,
        toggle: true,
        code: '',
        invitation: null,
        obj: {},
        selected: {
            country: null,
            state: null,
            CountryCode: _.first(config.country_codes)
        }
    }

    componentWillMount() {
        const { params } = this.props;
        const bgs = config.bgs;
        // Clear some things from previous sessions
        this.props.teamActions && this.props.teamActions.clearFamilyTeams();
        this.props.teamActions && this.props.teamActions.clearSelectedTeam();
        this.props.familyActions && this.props.familyActions.clearSelectedUser();
        this.props.familyActions && this.props.familyActions.clearFamily();
        this.props.geoActions && this.props.geoActions.fetchCountries();
        this.props.geoActions && this.props.geoActions.fetchCountryCodes();
        this.props.seasonActions && this.props.seasonActions.fetchDisclaimer(1);
        this.props.familyActions.fetchInvitation(params.token);
        this.setState({ selectedBg: _.sample(bgs), });

    }
    componentWillReceiveProps = nextProps => {
        const { invitation } = nextProps, { mode } = this.state;
        if (nextProps.country_codes) this.setState({ country_codes: nextProps.country_codes }, () => {
            if (this.state.country_codes && this.state.country_codes.northAmericanCountries && !this.state.selected.country_code) {
                const { selected } = this.state;

                selected.country_code = localStorage.getItem('sportslogic.referral.country_code') ?
                    (_.find(_.chain(this.state.country_codes).values().flatten().value(), c => c.countryCode === localStorage.getItem('sportslogic.referral.country_code')) ||
                        _.first(this.state.country_codes.northAmericanCountries)) : //selected.country_code.countryCode
                    _.first(this.state.country_codes.northAmericanCountries);

                selected.mask = _.chain(selected.country_code.phoneNumberMask)
                    .map(a => {
                        switch (a) {
                            case '/[2-9]/': return /[2-9]/;
                            case '/[1-9]/': return /[1-9]/;
                            case '/[0-9]/': return /[0-9]/;
                            case '/[5-9]/': return /[5-9]/;
                            case '/[2-5]/': return /[2-5]/;
                            case '/[2-6]/': return /[2-6]/;
                            case '/\d/': return /\d/;
                            default: return a;
                        }
                    }).value();

                this.setState({ selected, bootstrapped: true });

            }
            this.setState({ invitation, mode: 1 });
        });
        if (nextProps.countries && nextProps.countries.length && !this.state.selected.country) {
            this.selectCountry(
                _.find(nextProps.countries, c => {
                    if (localStorage.getItem('sportslogic.referral.country_code')) {
                        switch (localStorage.getItem('sportslogic.referral.country_code')) {
                            case '+44': return c.ISOCode === 'UK'; break;
                            default: return c.ISOCode === 'US'; break;
                        }
                    } else return c.ISOCode === 'US';
                })
            );
        }

    }

    onCountryCode = (c) => {
        const { selected } = this.state;
        selected.CountryCode = c;
        this.setState({ selected });
    }

    onCountry = (c) => {
        const { selected } = this.state;
        selected.country = c;
        this.props.geoActions && this.props.geoActions.clearStates && this.props.geoActions.clearStates();
        this.props.geoActions && this.props.geoActions.fetchStates && this.props.geoActions.fetchStates(c.IdCountry);
        this.setState({ selected });
    }

    selectCountry = (c) => {
        if (!c) return;
        const { selected } = this.state;
        selected.country = c;
        this.props.geoActions && this.props.geoActions.clearStates && this.props.geoActions.clearStates();
        this.props.geoActions && this.props.geoActions.fetchStates && this.props.geoActions.fetchStates(c.IdCountry);
        this.setState({ selected });
    }

    onGender = i => {
        const { invitation } = this.state;
        invitation.IdGender = i;
        this.setState({ invitation });
    }

    onState = (s) => {
        const { selected } = this.state;
        selected.state = s;
        this.setState({ selected });
    }

    selectUser = user => {
        if (user.Token) {
            fakeAuth.authenticate(() => {
                this.props.login({
                    token: user.Token,
                    isAdmin: user.IsLeagueAdmin
                });
                this.props.router.push(`/family`);
            }, user.Token,
                user.IsLeagueAdmin, user)
        }
    }

    doLogin = (e) => {
        e && e.preventDefault && e.preventDefault();
        var { invitation } = this.state;
        const dobNode = this.txtDob ? ReactDOM.findDOMNode(this.txtDob) : null;
        const phoneNode = this.txtPhone ? ReactDOM.findDOMNode(this.txtPhone) : null;

        const dobVal = dobNode ? dobNode.value : '';
        const phoneVal = phoneNode ? phoneNode.value : '';

        const invalidFields = {
            firstName: !this.txtFirstName?.value,
            lastName: !this.txtLastName?.value,
            dob: !dobVal,
            phone: this.state.selected.country_code ? !phoneVal : false,
            password: !this.txtPassword?.value,
            verpassword: !this.txtVerPassword?.value
        };

        const hasError = Object.values(invalidFields).some(v => v);

        if (hasError) {
            this.setState({ invalid: true, invalidFields, message: 'Please complete the missing fields' });
            return;
        }

        if (this.txtPassword.value !== this.txtVerPassword.value) {
            this.setState({ invalid: true, invalidFields: { password: true, verpassword: true }, message: 'Passwords do not match' });
            return;
        }

        // Mid-strength password validation: At least 6 characters, 1 letter and 1 number
        const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*#?&]{6,}$/;
        if (!passwordRegex.test(this.txtPassword.value)) {
            this.setState({
                invalid: true,
                invalidFields: { password: true, verpassword: true },
                message: 'Password must be at least 6 characters long and contain both letters and numbers'
            });
            return;
        }

        this.setState({ invalid: false, invalidFields: {} });       


        const { microTransac } = this.state;
        if (!microTransac) {
            this.setState({
                microTransac: true,
                invalid: false,
                email: invitation.EmailAddress
            }, () => {

                // Save the email on the localstorage for future usage
                localStorage.setItem('email', invitation.EmailAddress);

                // Call API                
                request.post(`${config.apiEndpoint}/api/v6/membership/invitation`)
                    .send({
                        Email: invitation.EmailAddress,
                        Password: this.txtPassword.value,
                        FirstName: this.txtFirstName.value,
                        LastName: this.txtLastName.value,
                        CountryCode: this.state.selected.country_code.countryCode,
                        Phone: ReactDOM.findDOMNode(this.txtPhone).value,
                        DOB: ReactDOM.findDOMNode(this.txtDob).value,
                        IdGender: invitation.IdGender,
                        IdUser: invitation.IdUser,
                        IdFamily: invitation.IdFamily
                    })
                    .then((data) => {
                        if (data.body.success) {

                            // Decrypt User Info
                            data.body.family.forEach(humanize_user);

                            this.setState({ toggle: false }, () => {
                                setTimeout(() => {
                                    this.setState({ users: data.body.family, toggle: true }, () => {
                                        this.selectUser(_.find(data.body.family, u => u.IdUser == invitation.IdUser));
                                    });
                                }, 400)
                            });

                        } else {
                            this.setState({ microTransac: false, invalid: true });
                        }

                    }, (error) => {
                        this.setState({
                            microTransac: false,
                            invalid: true,
                            message: 'Invalid Email or Password. Please check.', //body.error.message
                        });
                        this.props.setDeveloperMessage && this.props.setDeveloperMessage(error);
                    });
            });
        }
    }



    render() {
        const { mode, users, microTransac, email, toggle, code, invalid, message, league, invitation, country_codes, selected, obj } = this.state, { params } = this.props, { idLeague } = params;
        const { countries, states } = this.props;
        return (
            <Layout className="bg-black">
                <section style={{ position: 'absolute', top: 0, bottom: 0, left: 0, right: 0 }}>
                    <div className={`cover h-100 w-100 d-flex justify-content-end ${this.state.selectedBg}`} style={{ position: 'relative' }}>
                        <BlackOverlay />

                        {mode === 1 && invitation !== null && <Animated isVisible={(toggle && mode === 1) ? true : false} animationIn="fadeInRight" animationOut="fadeOutRight"
                            animationOutDuration={400} animationInDelay={400} animationInDuration={400} style={{ width: 800, zIndex: 1, borderRadius: 6 }}
                            className="bg-white align-self-center d-flex px-4">

                            <div className="w-100 text-center w3-hide-small">
                                <img alt="" src="/images/backgrounds/screenshots/app.png" className="w-75" />
                            </div>

                            <div className="w-100 d-flex flex-row px-4">
                                <form key="login-form" className='align-self-center w-100 d-flex flex-column'>
                                    <h1 className="sqwad-font black text-center mt-4">THE SQWAD</h1>

                                    <span className="black mt-2 font-12 line1 montserrat">Hi <b>{invitation.NameFirst}</b>. Recently you've been invited to form part of <b>{invitation.TeamName}</b> roster. Coach has pre-registered some information for you to verify here.</span>

                                    {this.state.error && <div className="p-3 d-flex flex-row font-10 white bg-danger" key="leftActions">
                                        <i className="align-self-center fas fa-exclamation-triangle margin-right-half text-warning font-20" />
                                        <span className="align-self-center">{this.state.error}</span>
                                    </div>}

                                    {/* FORM */}
                                    {/*<div key="email" className="w-100 mt-4 card" data-validate="Type user name">
                                        <input className="w-100 p-2 bordered" defaultValue={invitation?.EmailAddress} type="text" name="email" placeholder="Email" ref={(input) => this.txtEmail = input} />
                                    </div>*/}
                                    <div key="first_name" className="w-100 mt-2 card" data-validate="First Name">

                                        <input className={`w-100 p-2 bordered rounded ${this.state.invalidFields?.firstName ? 'border border-danger' : ''}`}
                                            style={this.state.invalidFields?.firstName ? { borderColor: '#dc3545', outline: 'none' } : {}} defaultValue={invitation?.NameFirst} type="text" name="first_name" placeholder="First Name" ref={(input) => this.txtFirstName = input} />
                                    </div>
                                    <div key="last_name" className="w-100 mt-2 card" data-validate="Last Name">
                                        <input className={`w-100 p-2 bordered rounded ${this.state.invalidFields?.lastName ? 'border border-danger' : ''}`}
                                            style={this.state.invalidFields?.lastName ? { borderColor: '#dc3545', outline: 'none' } : {}} defaultValue={invitation?.NameLast} type="text" name="last_name" placeholder="Last Name" ref={(input) => this.txtLastName = input} />
                                    </div>

                                    { /* Phone */}
                                    {country_codes && country_codes.northAmericanCountries && <div className={`d-flex mt-2`}>

                                        <Dropdown isOpen={this.state.isCountryCodeOpen ? true : false} toggle={() => this.setState({ isCountryCodeOpen: !this.state.isCountryCodeOpen })} className=" p-0 card tile" style={{ width: 200 }}>
                                            {/*<DropdownToggle style={{ paddingTop: 0, paddingBottom: 0, backgroundColor: 'transparent' }} className="h-100 w-100 text-left d-flex">
                                                                                    <img src={selected.CountryCode ? selected.CountryCode.image : ''} alt="" className="align-self-center mr-1" style={{ height: 20 }} />
                                                                                    <span className="black align-self-center font-12">{selected.CountryCode ? selected.CountryCode.value : 'Code'}</span>
                                            </DropdownToggle>*/}
                                            <DropdownToggle style={{ paddingTop: 0, paddingBottom: 0, backgroundColor: 'transparent' }} className="h-100 w-100 text-left d-flex">
                                                <img src={selected.country_code ? `https://api.thesqwad.com/images/flags/${selected.country_code.countryISOCode}.png` : ''} alt="" className="align-self-center mr-1" style={{ height: 20 }} />
                                                <span className="black align-self-center font-12">{selected.country_code ? selected.country_code.countryCode : 'Code'}</span>
                                                <i className="ml-auto fas fa-caret-down align-self-center black font-16" />
                                            </DropdownToggle>
                                            <DropdownMenu>

                                                <DropdownItem header>North America</DropdownItem>
                                                <DropdownItem divider />
                                                {country_codes.northAmericanCountries.map((c, i) => <DropdownItem key={i} onClick={() => {
                                                    const { selected } = this.state;
                                                    selected.country_code = c;
                                                    selected.mask = _.chain(c.phoneNumberMask)
                                                        .map(a => {
                                                            switch (a) {
                                                                case '/[2-9]/': return /[2-9]/;
                                                                case '/[1-9]/': return /[1-9]/;
                                                                case '/[0-9]/': return /[0-9]/;
                                                                case '/[5-9]/': return /[5-9]/;
                                                                case '/[2-5]/': return /[2-5]/;
                                                                case '/[2-6]/': return /[2-6]/;
                                                                case '/\d/': return /\d/;
                                                                default: return a;
                                                            }
                                                        }).value();
                                                    this.setState({ selected });
                                                }}>
                                                    <img src={`https://api.thesqwad.com/images/flags/${c.countryISOCode}.png`} alt="" style={{ height: 15 }} className="align-self-center mr-1" /> {c.countryName}
                                                </DropdownItem>)}

                                                <DropdownItem header>South America</DropdownItem>
                                                <DropdownItem divider />
                                                {country_codes.southAmericanCountries.map((c, i) => <DropdownItem key={i} onClick={() => {
                                                    const { selected } = this.state;
                                                    selected.country_code = c;
                                                    selected.mask = _.chain(c.phoneNumberMask)
                                                        .map(a => {
                                                            switch (a) {
                                                                case '/[2-9]/': return /[2-9]/;
                                                                case '/[1-9]/': return /[1-9]/;
                                                                case '/[0-9]/': return /[0-9]/;
                                                                case '/[5-9]/': return /[5-9]/;
                                                                case '/[2-5]/': return /[2-5]/;
                                                                case '/[2-6]/': return /[2-6]/;
                                                                case '/\d/': return /\d/;
                                                                default: return a;
                                                            }
                                                        }).value();
                                                    this.setState({ selected });
                                                }}>
                                                    <img src={`https://api.thesqwad.com/images/flags/${c.countryISOCode}.png`} alt="" style={{ height: 15 }} className="align-self-center mr-1" /> {c.countryName}
                                                </DropdownItem>)}

                                                <DropdownItem header>America Central</DropdownItem>
                                                <DropdownItem divider />
                                                {country_codes.centralAmericanCountries.map((c, i) => <DropdownItem key={i} onClick={() => {
                                                    const { selected } = this.state;
                                                    selected.country_code = c;
                                                    selected.mask = _.chain(c.phoneNumberMask)
                                                        .map(a => {
                                                            switch (a) {
                                                                case '/[2-9]/': return /[2-9]/;
                                                                case '/[1-9]/': return /[1-9]/;
                                                                case '/[0-9]/': return /[0-9]/;
                                                                case '/[5-9]/': return /[5-9]/;
                                                                case '/[2-5]/': return /[2-5]/;
                                                                case '/[2-6]/': return /[2-6]/;
                                                                case '/\d/': return /\d/;
                                                                default: return a;
                                                            }
                                                        }).value();
                                                    this.setState({ selected });
                                                }}>
                                                    <img src={`https://api.thesqwad.com/images/flags/${c.countryISOCode}.png`} alt="" style={{ height: 15 }} className="align-self-center mr-1" /> {c.countryName}
                                                </DropdownItem>)}

                                                <DropdownItem header>Europe</DropdownItem>
                                                <DropdownItem divider />
                                                {country_codes.europeanCountries.map((c, i) => <DropdownItem key={i} onClick={() => {
                                                    const { selected } = this.state;
                                                    selected.country_code = c;
                                                    selected.mask = _.chain(c.phoneNumberMask)
                                                        .map(a => {
                                                            switch (a) {
                                                                case '/[2-9]/': return /[2-9]/;
                                                                case '/[1-9]/': return /[1-9]/;
                                                                case '/[0-9]/': return /[0-9]/;
                                                                case '/[5-9]/': return /[5-9]/;
                                                                case '/[2-5]/': return /[2-5]/;
                                                                case '/[2-6]/': return /[2-6]/;
                                                                case '/\d/': return /\d/;
                                                                default: return a;
                                                            }
                                                        }).value();
                                                    this.setState({ selected });
                                                }}>
                                                    <img src={`https://api.thesqwad.com/images/flags/${c.countryISOCode}.png`} alt="" style={{ height: 15 }} className="align-self-center mr-1" /> {c.countryName}
                                                </DropdownItem>)}

                                                <DropdownItem header>Africa</DropdownItem>
                                                <DropdownItem divider />
                                                {country_codes.africanCountries.map((c, i) => <DropdownItem key={i} onClick={() => {
                                                    const { selected } = this.state;
                                                    selected.country_code = c;
                                                    selected.mask = _.chain(c.phoneNumberMask)
                                                        .map(a => {
                                                            switch (a) {
                                                                case '/[2-9]/': return /[2-9]/;
                                                                case '/[1-9]/': return /[1-9]/;
                                                                case '/[0-9]/': return /[0-9]/;
                                                                case '/[5-9]/': return /[5-9]/;
                                                                case '/[2-5]/': return /[2-5]/;
                                                                case '/[2-6]/': return /[2-6]/;
                                                                case '/\d/': return /\d/;
                                                                default: return a;
                                                            }
                                                        }).value();
                                                    this.setState({ selected });
                                                }}>
                                                    <img src={`https://api.thesqwad.com/images/flags/${c.countryISOCode}.png`} alt="" style={{ height: 15 }} className="align-self-center mr-1" /> {c.countryName}
                                                </DropdownItem>)}

                                                <DropdownItem header>Asia</DropdownItem>
                                                <DropdownItem divider />
                                                {country_codes.asianCountries.map((c, i) => <DropdownItem key={i} onClick={() => {
                                                    const { selected } = this.state;
                                                    selected.country_code = c;
                                                    selected.mask = _.chain(c.phoneNumberMask)
                                                        .map(a => {
                                                            switch (a) {
                                                                case '/[2-9]/': return /[2-9]/;
                                                                case '/[1-9]/': return /[1-9]/;
                                                                case '/[0-9]/': return /[0-9]/;
                                                                case '/[5-9]/': return /[5-9]/;
                                                                case '/[2-5]/': return /[2-5]/;
                                                                case '/[2-6]/': return /[2-6]/;
                                                                case '/\d/': return /\d/;
                                                                default: return a;
                                                            }
                                                        }).value();
                                                    this.setState({ selected });
                                                }}>
                                                    <img src={`https://api.thesqwad.com/images/flags/${c.countryISOCode}.png`} alt="" style={{ height: 15 }} className="align-self-center mr-1" /> {c.countryName}
                                                </DropdownItem>)}

                                                <DropdownItem header>Oceania</DropdownItem>
                                                <DropdownItem divider />
                                                {country_codes.oceaniaCountries.map((c, i) => <DropdownItem key={i} onClick={() => {
                                                    const { selected } = this.state;
                                                    selected.country_code = c;
                                                    selected.mask = _.chain(c.phoneNumberMask)
                                                        .map(a => {
                                                            switch (a) {
                                                                case '/[2-9]/': return /[2-9]/;
                                                                case '/[1-9]/': return /[1-9]/;
                                                                case '/[0-9]/': return /[0-9]/;
                                                                case '/[5-9]/': return /[5-9]/;
                                                                case '/[2-5]/': return /[2-5]/;
                                                                case '/[2-6]/': return /[2-6]/;
                                                                case '/\d/': return /\d/;
                                                                default: return a;
                                                            }
                                                        }).value();
                                                    this.setState({ selected });
                                                }}>
                                                    <img src={`https://api.thesqwad.com/images/flags/${c.countryISOCode}.png`} alt="" style={{ height: 15 }} className="align-self-center mr-1" /> {c.countryName}
                                                </DropdownItem>)}

                                            </DropdownMenu>
                                        </Dropdown>

                                        {/* PHONE NUMBER */}
                                        <div className="card tile w-100 ml-2">
                                            {selected.country_code && <MaskedInput guide={true} ref={(i) => this.txtPhone = i} className={`w-100 p-2 bordered rounded ${this.state.invalidFields?.phone ? 'border border-danger' : ''}`}
                                                style={this.state.invalidFields?.phone ? { borderColor: '#dc3545', outline: 'none' } : {}} placeholder="Phone Number (*)" defaultValue={invitation.PhoneNumber}
                                                mask={selected.mask} />}
                                        </div>
                                    </div>}


                                    <div className="card tile mt-2 bordered w-100">
                                        <div className="w-100 text-center">
                                            <div className="d-flex">
                                                <div className="w-100 text-center d-flex flex-column p-2" onClick={() => this.onGender(1)}>

                                                    <div style={{ width: 50, height: 50, border: `2px solid ${invitation.IdGender === 1 ? '#013469' : 'gray'}`, borderRadius: 25, overflow: 'hidden', backgroundColor: invitation.IdGender === 1 ? '#013469' : 'transparent' }} className="text-center m-auto d-flex flex-column justify-content-end">
                                                        <span className={`icon-man icon-men ${invitation.IdGender === 1 ? 'white' : 'gray'} font-40`}>
                                                            <span className="path1" />
                                                            <span className="path2" />
                                                            <span className="path3" />
                                                            <span className="path4" />
                                                            <span className="path5" />
                                                            <span className="path6" />
                                                            <span className="path7" />
                                                            <span className="path8" />
                                                            <span className="path9" />
                                                            <span className="path10" />
                                                            <span className="path11" />
                                                            <span className="path12" />
                                                            <span className="path13" />
                                                            <span className="path14" />
                                                            <span className="path15" />
                                                            <span className="path16" />
                                                            <span className="path17" />
                                                        </span>
                                                    </div>
                                                    <span className="font-10 black toUpper sqwad-font">Male</span>

                                                </div>
                                                <div className="w-100 text-center d-flex flex-column p-2" onClick={() => this.onGender(2)}>
                                                    <div style={{
                                                        width: 50, height: 50, border: `2px solid ${invitation.IdGender === 2 ? '#013469' : 'gray'}`, borderRadius: 25, overflow: 'hidden',
                                                        backgroundColor: invitation.IdGender === 2 ? '#013469' : 'transparent'
                                                    }} className="text-center m-auto d-flex flex-column justify-content-end">
                                                        <span className={`icon-woman ${invitation.IdGender === 2 ? 'white' : 'gray'} font-40`}>
                                                            <span className="path1" />
                                                            <span className="path2" />
                                                            <span className="path3" />
                                                            <span className="path4" />
                                                            <span className="path5" />
                                                            <span className="path6" />
                                                            <span className="path7" />
                                                            <span className="path8" />
                                                            <span className="path9" />
                                                            <span className="path10" />
                                                            <span className="path11" />
                                                            <span className="path12" />
                                                            <span className="path13" />
                                                            <span className="path14" />
                                                            <span className="path15" />
                                                        </span>
                                                    </div>
                                                    <span className="font-10 black toUpper sqwad-font">Female</span>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className={`${this.state.invalid_date ? 'bg-danger' : ''} card tile mt-2 `}>
                                        <MaskedInput defaultValue={moment(invitation.DateOfBirth, 'YYYY-MM-DD').format("MM/DD/YYYY")} placeholder="DOB (MM/DD/YYYY)" id="txtDoB" ref={(i) => this.txtDob = i} guide={true} className={`w-100 p-2 bordered rounded ${this.state.invalidFields?.dob ? 'border border-danger' : ''}`}
                                            style={this.state.invalidFields?.dob ? { borderColor: '#dc3545', outline: 'none' } : {}} mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]} />
                                    </div>
                                    <div className={`d-flex flex-row`}>
                                        <span className="font-10 align-self-center">(MM/DD/YYYY) {this.state.invalid_date && <i className="red">INVALID DATE. PLEASE FOLLOW THE FORMAT MM/DD/YYYY</i>}</span>
                                    </div>
                                    <hr />
                                    <div key="pass" className="w-100 mt-2" data-validate="Type password">
                                        <input
                                            className={`w-100 p-2 bordered rounded ${this.state.invalidFields?.password ? 'border border-danger' : ''}`}
                                            style={this.state.invalidFields?.password ? { borderColor: '#dc3545', outline: 'none' } : {}}
                                            type="password"
                                            name="pass"
                                            placeholder="New Password"
                                            ref={(input) => this.txtPassword = input}

                                        />
                                    </div>

                                    <div key="verpass" className="w-100 mt-2" data-validate="Type password">
                                        <input
                                            className={`w-100 p-2 bordered rounded ${this.state.invalidFields?.verpassword ? 'border border-danger' : ''}`}
                                            style={this.state.invalidFields?.verpassword ? { borderColor: '#dc3545', outline: 'none' } : {}}
                                            type="password"
                                            name="verpass"
                                            placeholder="Verify Password"
                                            ref={(input) => this.txtVerPassword = input}

                                        />
                                    </div>

                                    {/*<div key="pass" className="w-100 mt-2" data-validate="Type password">
                                        <input className="w-100 p-2 bordered" type="password" name="pass" placeholder="New Password" ref={(input) => this.txtPassword = input} />
                                    </div>
                                    <div key="verpass" className="w-100 mt-2" data-validate="Verify password">
                                        <input className="w-100 p-2 bordered" type="password" name="verpass" placeholder="Verify Password" ref={(input) => this.txtVerPassword = input} />
                                    </div>*/}

                                    { /* Submit Button */}
                                    <button type="submit" className="btn btn-info w-100 mt-4" onClick={this.doLogin}>
                                        {!microTransac && <span>Accept Invitation</span>}
                                        {microTransac && <i className="fa fa-spin fa-2x fa-cog" />}
                                    </button>

                                    { /* Error Message */}
                                    {invalid && <div className="d-flex flex-column p-2 bg-danger bd-highlight" style={{ width: '100%' }}>
                                        <span className="white align-self-center font-8">{message || 'Invalid Email or Password'}</span>
                                    </div>}

                                    <div style={{ height: 50 }} />
                                </form>
                            </div>

                        </Animated>}

                        {mode === 2 && <Animated isVisible={(toggle && mode === 2) ? true : false} animationIn="fadeInRightBig" animationOut="fadeOutRight" animationOutDuration={400} animationInDuration={400} style={{ width: 600, zIndex: 1, position: 'relative', borderRadius: 6 }} className="bg-white align-self-center d-flex flex-column pr-4">

                            <button type="button" className="btn btn-link p-2" onClick={this.back}>
                                <i className="fa fa-arrow-left" />
                                {' '}<span>Back</span>
                            </button>
                        </Animated>}



                        {/* LOGO AT TOP */}
                        <span className="sqwad-font white font-14" style={{ position: 'absolute', top: 20, left: 20 }}>THE SQWAD</span>

                        {/* STORE LINKS */}
                        <Animated animationInDelay={500} animationInDuration={300} animationIn="fadeInLeft" isVisible={true} animateOnMount={true} className="d-flex flex-row justify-content-center" style={{ position: 'absolute', bottom: 20, left: 20 }}>
                            <a className="align-self-center" target="_blank" rel="noopener noreferrer" href="https://apps.apple.com/us/app/the-sqwad/id1506954207"><img src="/images/icons/appstore.png" alt="" style={{ height: 30 }} /></a>
                            {/*<img alt="" className='ml-2 align-self-center' style={{ height: 70, width: 70 }} src="https://api.thesqwad.com/api/v5/qrcodes/url/10" />*/}
                            <a className="ms-2 ml-2 align-self-center" target="_blank" rel="noopener noreferrer" href="https://play.google.com/store/apps/details?id=com.trycatch.squad.app"><img src="/images/icons/playstore.png" alt="" style={{ height: 30 }} /></a>
                        </Animated>
                    </div>

                </section>
            </Layout>
        )
    }
}

export default Invitation;
